import { MapIcon } from "@heroicons/react/24/solid";
import { fullDeliveryAddress } from "../../../Utils";
import { isCompleteDeliveryAddress } from "../../../../constants/countries";

export const DeliveryAddressSection = (props) => {
  const { address } = props;
  const complete = isCompleteDeliveryAddress(address);

  return (
    <section className="overflow-hidden rounded-[18px] border border-slate-200 bg-white shadow-[0_1px_2px_rgba(0,0,0,.04)]">
      <div className="flex items-center px-5 py-5">
        <div className="block w-[60%]">
          <h2 className="text-[15px] font-extrabold text-slate-900">
            Leveringsadresse
          </h2>
          <p className="mt-1 max-w-2xl text-sm text-slate-600">
            {address?.id ? fullDeliveryAddress(address) : "Ikke valgt"}
          </p>
          {address?.id && !complete ? (
            <p className="mt-2 text-sm font-medium text-amber-700">
              Adressen mangler land eller er ufullstendig. Tripletex krever land
              på fraktseddel.
            </p>
          ) : null}
        </div>
        <div className="w-[40%] text-right">
          {address?.id && (
            <a
              href={"https://www.google.com/maps?q=" + fullDeliveryAddress(address)}
              rel="noreferrer"
              target="_blank"
              className="inline-flex items-center rounded-xl bg-[#1463C7] px-3 py-2 text-sm font-semibold text-white shadow-[0_12px_24px_-8px_rgba(20,99,199,.55)]"
            >
              <MapIcon className="h-4 w-4" aria-hidden="true" />
              <span className="ml-2">Google</span>
            </a>
          )}
        </div>
      </div>
    </section>
  );
};
